<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div>
        <v-row>
          <v-col cols="6">
            <v-breadcrumbs
              class="pl-0 pb-10"
              :items="breadcrumbs"
              divider=">"
            ></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <download-excel
              ref="excelDownload"
              class="btn btn-default text-white"
              :data="export_data"
              :fields="export_field"
              :type="exportType"
              :worksheet="exportWorksheet"
              :name="exportFileName"
            />
            <v-btn
              class="export-btn btn-color mr-4 text-white"
              :disabled="isFetching"
              @click="handleExport"
            >
              <v-icon left>mdi-download</v-icon>
              <span v-if="!isFetching" style="font-size: 15px !important;">Export Data</span>
              <span v-else style="font-size: 15px !important;">Loading...</span>
            </v-btn>
            <!-- <v-btn class="export-btn btn-color" dark color="yellow-light">
              <v-icon left>mdi-download</v-icon>
              <download-excel
                class="btn btn-default text-white"
                :data="export_data"
                :fields="export_field"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
              >
                Export Data
              </download-excel>
            </v-btn> -->

            <!-- <v-btn class="export-btn btn-color" dark>
              <v-icon left>mdi-download</v-icon>
              <download-excel
                class="btn btn-default text-white"
                :data="export_data1"
                :fields="export_field"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFile"
              >
                Line User Id
              </download-excel>
            </v-btn> -->
          </v-col>
        </v-row>
        <v-row>
          <!-- Data -->
          <v-dialog v-model="dialogData" persistent max-width="30%">
            <v-card max-width="100%">
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <template slot="progress">
                      <v-progress-linear
                        color="deep-purple"
                        height="10"
                        indeterminate
                      ></v-progress-linear>
                    </template>

                    <v-avatar
                      color="teal"
                      size="190"
                      style="margin-bottom:50px"
                    >
                      <img alt="user" :src="this.fromUpdate.picture" />
                    </v-avatar>
                    <v-card-text
                      align="center"
                      class="mx-0"
                      style="position:absolute;top: 205px;z-index: 2;background-color: white;width: 150px;"
                    >
                      <div class="my-4 text-subtitle-1">ข้อมูลส่วนตัว</div>
                    </v-card-text>

                    <v-card-text align="left" class="mx-0" style="z-index: 1;">
                      <div
                        style="padding:20px;padding-top:20px; border: 2px solid #A5BECC; border-radius: 25px;margin-bottom: 10px;"
                      >
                        <div style="font-weight: bold">ชื่อลูกค้า</div>
                        <v-text-field
                          style="padding:10px !important"
                          outlined
                          hide-details
                          dense
                          v-model="fromUpdate.name"
                        ></v-text-field>
                        <div style="font-weight: bold">เบอร์โทรศัพท์</div>
                        <v-text-field
                          style="padding:10px !important"
                          hide-details
                          outlined
                          dense
                          v-model="fromUpdate.tel"
                        ></v-text-field>
                        <div style="font-weight: bold">
                          วันเกิด
                        </div>
                        <v-text-field
                          style="padding:10px !important"
                          hide-details
                          outlined
                          dense
                          v-model="fromUpdate.birthDay"
                        ></v-text-field>
                      </div>
                      <h4
                        v-if="memberActivity.length > 0"
                        style="font-weight: bold;z-index: 2;"
                      >
                        กิจกรรมกรอกข้อมูลที่ลูกค้าเคยเข้าร่วม
                      </h4>
                      <div
                        v-if="memberActivity.length > 0"
                        style="z-index: 1;padding:20px;padding-top:20px; border: 2px solid #A5BECC; border-radius: 25px;margin-bottom: 10px;"
                      >
                        <div v-for="(item, i) in memberActivity" :key="i">
                          <!-- <div style="font-weight: normal">{{ item.title }}</div> -->
                          <v-text-field
                            v-if="item.field1Value"
                            :label="item.field1Title"
                            outlined
                            dense
                            v-model="item.field1Value"
                          ></v-text-field>
                          <v-text-field
                            v-if="item.field2Value"
                            :label="item.field2Title"
                            outlined
                            dense
                            v-model="item.field2Value"
                          ></v-text-field>
                          <!-- <div>{{item.title}}</div>
                        <div>{{item.field1Title}}</div> -->
                        </div>
                      </div>
                    </v-card-text>

                    <v-btn
                      elevation="2"
                      class="btn-color"
                      dark
                      x-large
                      @click="dialogData = false"
                    >
                      <!-- <v-icon left>mdi-close-circle-outline</v-icon> -->
                      ปิด
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->
          <!-- data table -->
          <v-row class="px-6">
            <v-col cols="4">
              <v-text-field
                outlined
                v-model="searchAll2"
                label="เบอร์โทรศัพท์"
                hide-details
                clearable
                @click:clear="onClear"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="4" style="display: flex;align-items: center">
              <v-btn @click="searchTel" dark color="primary">
                ค้นหา
              </v-btn>
            </v-col>
          </v-row>
          <v-col cols="12">
            <div elevation="7">
              <!-- <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title> -->
              <v-card-text>
                <v-data-table
                  :loading="!dataReady"
                  loading-text="กำลังโหลดข้อมูล..."
                  :headers="columns"
                  :items="dataItem"
                  :items-per-page="10"
                  :page.sync="currentPage"
                  :server-items-length="totalItems"
                  @update:page="onPageChange"
                >
                  <template v-slot:[`item.currentPoint`]="{ item }">
                    {{ formatNumber(item.currentPoint) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.picture`]="{ item }">
                    <v-avatar color="primary" size="40">
                      <img :src="item.picture" alt="img"
                    /></v-avatar>
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          dark
                          class="btn-color"
                          fab
                          x-small
                          @click.stop=";(dialogData = true), getDataById(item)"
                        >
                          <v-icon dark> mdi-account </v-icon>
                        </v-btn>
                      </template>
                      <span>ดูข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </div>
            <!-- <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div> -->
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import VuetifyMoney from '../VuetifyMoney.vue'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    VuetifyMoney
  },
  // created () {
  //   setInterval(this.getNowGlobal, 1000)
  // },
  data () {
    return {
      PK: '',
      path: '/member/', // Path Model
      returnLink: '/system/ListMember',
      memberActivity: [],
      currentPage: 1,
      itemsPerPage: 10,
      a: [],
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายการลูกค้า',
          disabled: false,
          href: '/System/ListMember'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      // End Menu Config
      dataReady: true,
      totalItems: 28878,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      code: 'BCH_', // Generate Code
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogData: false,
      fromUpdate: [],
      // END Dialog Config ADD EDIT DELETE
      panel: [1],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: null,
      // Search Advanced
      search: {
        shopId: '',
        name: '',
        totalPoint: '',
        LevelName: ''
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'รูปโปรไฟล์', value: 'picture' },
        { text: 'ชื่อลูกค้า', value: 'name', align: 'left' },
        { text: 'เบอร์โทรศัพท์', value: 'tel', align: 'center' },
        { text: 'คะแนนที่ได้รับ', value: 'collectPoint', align: 'center' },
        { text: 'คะแนนที่ถูกใช้', value: 'redeemPoint', align: 'center' },
        { text: 'คะแนนคงเหลือ', value: 'currentPoint', align: 'center' },
        { text: 'วันเกิด', value: 'birthDay', align: 'center' },
        {
          text: 'คะแนนหมดอายุเดือนนี้',
          value: 'balancePoint',
          align: 'center'
        },
        { text: 'ระดับ', value: 'LevelName', align: 'left' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE', align: 'center' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE', align: 'center' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      // End Data Table Config

      // Config Import
      columnsImport: [
        { text: 'masBranchID', value: 'masBranchID' },
        { text: 'masBranchCode', value: 'masBranchCode' },
        { text: 'masBranchName', value: 'masBranchName' },
        { text: 'masCompanyCode', value: 'masCompanyCode' },
        { text: 'masCompanyName', value: 'masCompanyName' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      // End Config Import
      // Export Config
      exportType: 'xls',
      exportFileName: 'List-Member.xls',
      exportFile: 'รายชื่อผู้ใช้ที่จะถูกตัดคะแนนประจำเดือน.xls',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        lineId: 'linUserId',
        name: 'name',
        ระดับสมาชิก: 'LevelName',
        เบอร์โทรศัพท์: 'tel',
        วันที่สมัครสมาชิก: 'CREATE_DATE',
        คำตอบ1: 'field1Value',
        หัวข้อ2: 'field2Title',
        คำตอบ2: 'field2Value',
        หัวข้อ3: 'field3Title',
        คำตอบ3: 'field3Value',
        หัวข้อ4: 'field4Title',
        คำตอบ4: 'field4Value'
      },
      export_field: {
        linUserId: 'liffUserId',
        ชื่อ: 'name',
        เบอร์โทรศัพท์: 'tel',
        คะแนนที่ได้รับ: 'collectPoint',
        คะแนนที่ถูกใช้: 'redeemPoint',
        คะแนนคงเหลือ: 'currentPoint',
        คะแนนที่จะถูกตัดเดือนนี้: 'balancePoint',
        วันเกิด: 'birthDay',
        ระดับ: 'LevelName',
        วันที่สร้าง: 'CREATE_DATE',
        วันที่อัพเดท: 'LAST_DATE'
      },
      export_data1: null,
      export_data: null,
      off: 0,
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      // End Export Config
      Company: [],
      isFetching: false
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getGetToken(this.DNS_IP)
    this.dataReady = false
    // Get Data
    this.getDataList()
    this.getExportData()
    // this.Export_LineUserId()
  },
  methods: {
    onClear () {
      this.searchAll2 = null
      this.getDataList()
    },
    async searchTel () {
      // this.searchAll2
      this.dataReady = false
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ช่องค้นหา
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            // this.path +
            '/member/get?shopId=' +
            this.session.data.shopId + `&tel=${this.searchAll2}`
        )
        .then(async response => {
          if (response.data.length > 0) {
            console.log('getData', response.data)
            this.dataReady = true
            this.dataItem = response.data
            console.log('this.dataItem', this.dataItem)
          } else {
            this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
            this.dataReady = true
          }
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          //   this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    exportToExcel (data) {
      const worksheet = XLSX.utils.json_to_sheet(data) // แปลง JSON เป็น worksheet
      const workbook = XLSX.utils.book_new() // สร้าง workbook ใหม่
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Data') // เพิ่ม worksheet ใน workbook
      XLSX.writeFile(workbook, 'export_data.xlsx') // สร้างและดาวน์โหลดไฟล์
    },
    async handleExport () {
      try {
        this.isFetching = true // เริ่มโหลดข้อมูล
        const response = await this.fetchExportData() // เรียก API
        this.export_data = response.data // กำหนดข้อมูลที่โหลดมา
        this.exportToExcel(this.export_data)
      } catch (error) {
        console.error('Error fetching export data:', error)
      } finally {
        this.isFetching = false // เสร็จสิ้น
      }
    },
    async fetchExportData () {
      // ตัวอย่าง API call (เปลี่ยน URL และการจัดการให้ตรงกับระบบของคุณ)
      return axios.get(
        // eslint-disable-next-line quotes
        this.DNS_IP +
            // this.path +
            '/member/Member_Ex?shopId=' +
            this.session.data.shopId
      )
    },
    onPageChange (page) {
      console.log('page', page)
      if (page === 1) {
        this.off = 0
      } else {
        this.off = page * 10
      }
      this.getDataList(page)
    },
    async getDataList () {
      this.dataReady = false
      // Clear Data ทุกครั้ง
      this.dataItem = []
      // Clear ช่องค้นหา
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            // this.path +
            '/member/Member?shopId=' +
            this.session.data.shopId + `&offset=${this.off}`
        )
        .then(async response => {
          if (response.data.length > 0) {
            console.log('getData', response.data)
            this.dataReady = true
            this.dataItem = response.data
            console.log('this.dataItem', this.dataItem)
          } else {
            this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
            this.dataReady = true
          }
          this.export_data = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          //   this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search = '?name=' + this.searchAll + '&shopId=' + this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(
        this.DNS_IP,
        this.path,
        search,
        this.session.data.shopId,
        this.returnLink
      )
    },
    async getExportData () {
      console.log(this.session.data.shopId)
      await axios
        .get(
          this.DNS_IP + '/get-history-activity/get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          console.log(response.data)
          this.export_data1 = response.data
        })
        .catch(error => {
          console.log(error)
          this.dataReady = true
        })
    },
    Export_LineUserId () {
      axios
        .get(
          this.DNS_IP + '/member/Member_Ex?shopId=' + this.session.data.shopId
        )
        .then(async response => {
          console.log(response.data)
          this.export_data1 = response.data
        })
    },
    async saerchDataAdvanced () {
      var search = ''
      var check = false

      for (var key in this.search) {
        check = true
        if (this.search[key]) {
          if (search !== '') {
            search += '&'
          }
          search += key + '=' + this.search[key]
        }

        if (
          this.search.last_date_start === '' &&
          this.search.last_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่แก้ไข เริ่มต้น', 'error')
        }

        if (
          this.search.create_date_start === '' &&
          this.search.create_date_end !== ''
        ) {
          check = false
          this.$swal('ผิดพลาด', 'กรุณาเลือกวันที่สร้าง เริ่มต้น', 'error')
        }
      }
      if (check === true) {
        this.dataReady = false

        this.saerchDataAdvancedGlobal(
          this.DNS_IP,
          this.path,
          search,
          this.session.data.shopId,
          this.returnLink
        )
      } else {
        this.dataReady = true
      }
    },
    async getDataById (item) {
      console.log('item', this.session.data.shopId)
      this.fromUpdate.name = item.name
      this.fromUpdate.point = item.point
      this.fromUpdate.level = item.level
      this.fromUpdate.picture = item.picture
      this.fromUpdate.tel = item.tel
      this.fromUpdate.birthDay = item.birthDay
      let rs = await axios.get(
        this.DNS_IP +
          '/get-member-activity/get?lineUserId=' +
          item.liffUserId +
          '&shopId=' +
          this.session.data.shopId
      )
      this.memberActivity = rs.data
      console.log('ddddd', this.memberActivity)
    },
    async clearData () {
      for (var key in this.search) {
        if (this.search[key]) {
          this.search[key] = ''
        }
      }
    }
  }
}
</script>
<style scope>
/* เปลี่ยนสีของไอคอน chevron */
.v-icon.mdi-chevron-right {
  color: black !important;
}

.v-icon.mdi-chevron-left {
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/System/ListMember.vue